/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { configureStore } from '@reduxjs/toolkit'

/**********************************************************************************************************
 *   APIs
 **********************************************************************************************************/
import { appAPI } from 'api/app'
import { accountAPI } from 'api/account'
import { shopAPI } from 'api/shop'
import { domainAPI } from 'api/domain'
import { serviceAPI } from 'api/service'
import { billingAPI } from 'api/billing'
import { supportAPI } from 'api/support'

/**********************************************************************************************************
 *   SLICES
 **********************************************************************************************************/
import appSlice from 'store/slices/appSlice'
import accountSlice from 'store/slices/accountSlice'
import domainSlice from 'store/slices/domainSlice'
import serviceSlice from 'store/slices/serviceSlice'
import shopSlice from 'store/slices/shopSlice'
import supportSlice from 'store/slices/supportSlice'
import alertSlice from 'store/slices/alertSlice'
import billingSlice from 'store/slices/billingSlice'

/**********************************************************************************************************
 *   MIDDLEWARES
 **********************************************************************************************************/
import { alert } from 'api/middleware/alert'
import { fetching } from 'api/middleware/fetching'

/**********************************************************************************************************
 *   STORE CONFIGURE
 **********************************************************************************************************/
export const store = configureStore({
    reducer: {
        app: appSlice,
        account: accountSlice,
        domain: domainSlice,
        service: serviceSlice,
        shop: shopSlice,
        support: supportSlice,
        alerts: alertSlice,
        billing: billingSlice,
        [appAPI.reducerPath]: appAPI.reducer,
        [accountAPI.reducerPath]: accountAPI.reducer,
        [domainAPI.reducerPath]: domainAPI.reducer,
        [serviceAPI.reducerPath]: serviceAPI.reducer,
        [supportAPI.reducerPath]: supportAPI.reducer,
        [shopAPI.reducerPath]: shopAPI.reducer,
        [billingAPI.reducerPath]: billingAPI.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            alert,
            fetching,
            appAPI.middleware,
            accountAPI.middleware,
            domainAPI.middleware,
            serviceAPI.middleware,
            supportAPI.middleware,
            shopAPI.middleware,
            billingAPI.middleware
        )
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
